export const state = {
	isProcessingActive: false
};

export const getters = {
	isProcessingActive: state => {
		return state.isProcessingActive;
	}
};

export const mutations = {
	SET_PROCESS_ACTIVE (state) {
		state.isProcessingActive = true;
	},
	SET_PROCESS_INACTIVE (state) {
		state.isProcessingActive = false;
	}
};

export const actions = {
	setProcessActive ({ commit }) {
		commit('SET_PROCESS_ACTIVE');
	},
	setProcessInactive ({ commit }) {
		commit('SET_PROCESS_INACTIVE');
	}
};